import React from "react"
import PropTypes from "prop-types"
import Grid from "../../grid"
import { H2, H3, P } from "../../typography"
import { Experience } from "./styles"

const WorkExperience = ({ work_experiences }) => (
  <>
    <H2 variant="primary" profile>
      Work Experience
    </H2>

    <Grid gap="24px">
      {work_experiences.length > 0 ? (
        <Grid>
          {work_experiences.map((work_experience) => (
            <Experience key={work_experience.id}>
              <Grid gap="16px">
                <H3 marginless profile variant="content">
                  {work_experience.job_title}
                </H3>
                <Grid gap="16px" template="auto / 1fr 1fr">
                  <Grid gap="4px">
                    <P marginless profileLabel>
                      Name
                    </P>
                    <P marginless profileData>
                      {work_experience.employer_name}
                    </P>
                  </Grid>

                  <Grid gap="4px">
                    <P marginless profileLabel>
                      Period
                    </P>
                    <P marginless profileData>
                      {work_experience.dates}
                    </P>
                  </Grid>
                </Grid>

                <P marginless variant="content" profileData>
                  {work_experience.job_description}
                </P>
              </Grid>
            </Experience>
          ))}
        </Grid>
      ) : (
        <P marginless profileData>
          No work experience.
        </P>
      )}
    </Grid>
  </>
)

WorkExperience.propTypes = {
  work_experiences: PropTypes.array.isRequired
}

WorkExperience.defaultProps = {
  work_experiences: []
}

export default WorkExperience
